
class SignupController {
    constructor(PatientConnectionService, $state) {
        'ngInject';
        this.PatientConnectionService = PatientConnectionService;
        this.$state = $state;
    }

    $onInit() {
        this.password = '';
        this.emailAddress = this.emailAddress || '';
        this.emailToken = this.emailToken || '';
        this.userFullName = this.userFullName || '';
    }

    handleSubmitPassword($event) {
        this.password = $event.password;
        this.PatientConnectionService.signupPatientConnectionUser(this.emailToken, this.emailAddress, this.password, $event.hipaaAuthorized, $event.hipaaAuthorizedAt, $event.hipaaAuthorizedVersion)
            .then(this.onSignup);
    }
}

export const SignupComponent = {
    name: 'mmsPatientConnectionSignup',
    component: {
        template: `
            <section>
                <mms-banner banner-label="Create Password"></mms-banner>
                <mms-password-form user-full-name="$ctrl.userFullName" on-submit-password="$ctrl.handleSubmitPassword($event)"></mms-password-form>
            </section>
        `,
        controller: SignupController,
        bindings: {
            emailAddress: '<',
            emailToken: '<',
            userFullName: '<',
            onSignup: '&'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/signup/patientConnection.signup.component.js